<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
      <div class="col-md-9 ps-5">
        <h2 class="col pb-2 title">
          {{ "SCHEDULED" | translate }} {{ "ENERGY_REGISTER_DATA" | translate }}
        </h2>
        <h6 class="col subtitle">{{ "SCHEDULEDENERGY_SUBTITLE" | translate }}</h6>
      </div>
      <div class="col-md-3 d-flex justify-content-end align-items-center gap-3 pe-5">
        @if (
        authService.isAuthorized([PermissionsEnum.Scheduled_energyregister_bulk_download]) && data.length > 0
        ) {
        <button class="col-auto add justify-content-center" (click)="downloadSelected()">
          {{ "DOWNLOAD" | translate }}
        </button>
        }
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-10 d-flex flex-wrap g-0 m-0 ps-5 pb-2 gap-2 pt-2">
        <app-scheduled-data-filter
          [selectedAssetTypes]="selectedFilters.selectedAssetTypes"
          [selectedAreas]="selectedFilters.areas"
          [selectedRegions]="selectedFilters.regions"
          (applied)="onDataReceived($event)">
        </app-scheduled-data-filter>
        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleModal()"
                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleModal()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
          }
        </div>
        <span *ngIf="selectedRows.length > 0" class="ps-4 pe-3 custom-color d-flex align-items-center gap-2">
          {{selectedRows.length}} Selected
          <img alt="Clear" src="assets/device/x.svg" (click)="clearSelection()" title="Clear selection" />
        </span>
      </div>
    </div>
    <div>
      <div class="row g-0 m-0 pt-3 table-scroll">
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="ps-1">
                <input type="checkbox" [checked]="isHeaderChecked" (change)="toggleAllSelected($event)"
                  (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "LAST_READ_TIME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_SERVICENAME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_AREA" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "REGION" | translate }}</span>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data" (click)="rowClick(row.meterId!)">
              <td appIsNew [executedTime]="row.readOnMeterTime!" [seconds]="dayInMs"></td>
              <td class="ps-1" (click)="checkbox.click(); $event.stopPropagation()">
                <input type="checkbox" [checked]="isRowSelected(row.meterId)" [id]="'checkbox-' + row.meterId"
                  (click)="toggleRowSelection(row, $event)"
                  class="form-check-input custom-checkbox" #checkbox />
              </td>
              <td>
                <span>{{
                  row.readOnMeterTime | date: "dd MMM yyyy, h:mm a"
                  }}</span>
              </td>
              <td>
                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event)" class="copyable">
                  {{ row.meterNumber }}
                  <span class="copy-tooltip" *ngIf="clipboardService.copiedText === row.meterNumber">{{"COPIED" |
                    translate}}</span>
                </span>
              </td>
              <td>
                <span>{{ row.serviceName }}</span>
              </td>
              <td>
                <span>{{ row.assetType }}</span>
              </td>
              <td>
                <span>{{ row.area }}</span>
              </td>
              <td>
                <span>{{ row.region }}</span>
              </td>
              <td>
                <svg-icon alt="Magnifier" class="hover-effect" src="assets/device/magnifier.svg"
                  (click)="rowClick(row.meterId!)"></svg-icon>
              </td>
              <td>
                @if(authService.isAuthorized([PermisssionEnum.Scheduled_energyregister_download])){
                <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg" (click)="
                      $event.stopPropagation();
                      download(row.meterId!)
                    "></svg-icon>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container-down">
      <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
        [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
  </div>
</div>